<template>
  <!-- intro-section -->
  <div>
    <section
      id="inicio"
      class="intro-ten-Wrap text-left"
    >
      <b-container>
        <b-row>
          <b-col
            lg="6"
            md="12"
            class="intro-ten-LeftSection pb-3"
          >
            <h1 class="font-weight-bold text-50 mb-3">
              Convocatorias para la Universidad de la Policía
            </h1>
            <p class="text-18 mb-4 text-dark">
              Participa en el proceso de reclutamiento, selección e ingreso de
              aspirantes a la policía de la Secretaria de Seguridad Ciudadana de
              la Ciudad de México.
            </p>
            <div class="intro-ten-Buttons">
              <div>
                <scrollactive
                  style="display: flex; aligh-items: stretch;"
                  active-class="active"
                  :offset="80"
                >
                  <b-button
                    href="#convocatorias"
                    class="btn-lg px-5 py-2 mb-4 text-uppercase link scrollactive-item"
                    style="flex: 1 1 0%;"
                    variant="primary"
                  >
                    CONVOCATORIAS
                  </b-button>
                </scrollactive>
              </div>
            </div>
          </b-col>
          <b-col
            md="6"
            class=""
          >
            <div class="">
              <img
                src="@/assets/images/unipol/inicio-up.svg"
                class="img-responsive img-inicio d-none d-lg-block float-right"
                alt="img-intro"
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="overlay" />
    </section>
  </div>

</template>

<script>
import {
  BButton, BCol, BContainer, BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BCol,
    BContainer,
    BRow,
  },
}
</script>

<style scoped>
.text-dark {
  color: #4b4b4b;
  line-height: 1.5;
}
</style>
